<template>
    <div class="board" v-if="formData">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span>บิลที่ขอเคลม</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="text-center" v-if="isShowButtonLookup">
                <button class="btn btn-red" @click="openLookupPurchased()">ค้นหาสินค้าที่ขายออกไป</button>
            </div>

            <div class="form" v-if="isShowBillInfo">
                <div class="dashed-line mt-4 mb-4" v-if="isShowButtonLookup"></div>

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เลขที่บิล</label>
                            <input type="text" class="input-field" v-model="formData.bill.number" readonly />
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>วันที่ขายสินค้า</label>
                            <div class="input-datepicker">
                                <input type="text"
                                    class="input-field"
                                    :value="$AppUtility.displayOnlyDate(formData.bill.purchaseDate)" readonly />
                                <b-icon icon="calendar2-minus"></b-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <job-modal-claim-lookup :isDisplay="isShowLookupPurchased" @hide="closeLookupPurchased($event)"></job-modal-claim-lookup>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import JobModalClaimLookup from '@/components/job/claim/ModalClaimLookup';

export default {
    mixins: [ MixinThemeBoard ],
    components: {
        JobModalClaimLookup
    },
    data() {
        return {
            isShowButtonLookup: true,
            isShowLookupPurchased: false,
            isShowBillInfo: false,
            formData: null
        }
    },
    props: {
        jobState: Number,
        loadData: Object
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);

            if (this.loadData) {
                if (this.loadData.status !== this.$Constants.JOB_STATUS_NEW) {
                    this.initPendingDisplay();
                }
            }
        },
        initForm() {
            return {
                bill: {
                    number: this.loadData ? this.loadData.bill.number : '',
                    purchaseDate: this.loadData ? this.loadData.bill.purchaseDate : ''
                }
            }
        },
        initPendingDisplay() {
            this.isShowButtonLookup = false;
            this.isShowBillInfo = true;
        },
        setupBillData(data) {
            this.formData.bill.number = data.number;
            this.formData.bill.purchaseDate = data.closeDate;
        },
        openLookupPurchased() {
            this.isShowLookupPurchased = true;
        },
        closeLookupPurchased(data) {
            if (data) {
                this.isShowBillInfo = true;
                this.setupBillData(data);

                this.$emit('selectPurchased', data);
            }

            this.isShowLookupPurchased = false;
        }
    }
}
</script>